import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToServices = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Verifica si la navegación proviene del botón específico
    const shouldScrollToServices = localStorage.getItem('navigateToServices') === 'true';

    if (shouldScrollToServices) {
      // Encontrar la sección de servicios y enfocar directamente
      const servicesSection = document.getElementById('services');
      if (servicesSection) {
        servicesSection.scrollIntoView({ behavior: 'auto', block: 'start' });
      }

      // Limpia la señal para futuras navegaciones
      localStorage.removeItem('navigateToServices');
    }
  }, [pathname]);

  return null;
};

export default ScrollToServices;
